import { DialogSidebarType, DialogsSlice } from "../slice"
import { WritableDraft } from "immer/dist/internal"

export const updateSidebarContext = (
    state: WritableDraft<DialogsSlice>,
    sidebarType: DialogSidebarType,
    isOpening: boolean
): void => {
    if (isOpening) {
        if (!state.sidebarsContext.includes(sidebarType)) {
            state.sidebarsContext.push(sidebarType)
        }
    } else {
        const index = state.sidebarsContext.indexOf(sidebarType)
        if (index !== -1) {
            state.sidebarsContext.splice(index, 1)
        }
    }
}

export const getDialogSidebarTypeZIndex = (
    dialogSidebarsContext: DialogSidebarType[],
    sidebarType: DialogSidebarType
): number => {
    let zIndex = 1000

    const foundSidebarIndex = dialogSidebarsContext.findIndex(
        (currSidebarType: DialogSidebarType) => currSidebarType === sidebarType
    )

    zIndex += foundSidebarIndex

    return zIndex
}
